import {DeserializeCallbackFunc, IPropSchema} from '@mintdata/mint-kit/impl/util/serializr/src/api/types';
import {invariant} from '../utils/utils';

/**
 * Similar to primitive, serializes instances of Date objects
 *
 * @returns
 */
export function date():IPropSchema
{
    // TODO: add format option?
    return {
        serializer: function(value:any):number
        {
            if( value === null || value === undefined )
                return value;

            invariant(value instanceof Date, 'Expected Date object');

            return value.getTime();
        },
        deserializer: function(jsonValue:number, done:DeserializeCallbackFunc):void
        {
            if( jsonValue === null || jsonValue === undefined )
                return done(null, jsonValue);

            done(null, new Date(jsonValue));
        }
    };
}
